
export type GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType = typeof GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType[keyof typeof GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType = {
  PDF: 'PDF',
  LINK: 'LINK',
  CODE: 'CODE',
  DOWNLOAD: 'DOWNLOAD',
} as const;
